import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { useEffect } from 'react';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

class GamePlayStore extends BaseStore {
  constructor(props) {
    super();
    Object.assign(this, props);
  }

  @observable initState = -1;

  @observable activeIndex = 0;

  @observable layerData;

  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }

  expandPlay = index => {
    this.activeIndex = this.activeIndex === index ? -1 : index;
  };

  use() {
    const data = useFunLinkPageData();

    useEffect(
      () => {
        if (!data) {
          return;
        }
        //console.log('data', data);
        this.layerData = data;
      },
      [data]
    );
  }
}

export default GamePlayStore;
